// noinspection JSVoidFunctionReturnValueUsed

export default (function ($) {
  'use strict';

  $(document).ready(function () {
    // Accessible modal references
    // https://bitsofco.de/accessible-modal-dialog/
    // https://uxdesign.cc/how-to-trap-focus-inside-modal-to-make-it-ada-compliant-6a50f9a70700

    const radioContainer = $('#radio-container');
    const searchCloseBtn = $('#search-close');
    const searchOpenBtn = $('#search-open');
    const searchFormContainer = $('.js-search-form-container');
    const searchInput = $('#search-form-input');
    let focusedBeforeOpen;

    searchOpenBtn.length && searchOpenBtn.bind('click', function () {
      focusedBeforeOpen = $(this);
      searchFormContainer.removeClass('hidden invisible');
      searchInput.focus();
    });

    searchCloseBtn.length && searchCloseBtn.bind('click', function () {
      searchFormContainer.addClass('hidden invisible');
      focusedBeforeOpen.focus();
    });

    const modal = document.querySelector('#search-modal');

    // Search form won't be inside a modal on welcome page so we won't need this logic there.
    if (modal) {
      // add all the elements inside modal which you want to make focusable
      const focusableElements = 'button, input';

      const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
      const focusableContent = modal.querySelectorAll(focusableElements);
      const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

      document.addEventListener('keydown', function (e) {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
        let isEscPressed = e.key === 'Escape' || e.keyCode === 27;

        if (!isTabPressed && !isEscPressed) {
          return;
        }

        if (isEscPressed) {
          searchFormContainer.addClass('hidden invisible');
          focusedBeforeOpen.focus();
        }

        if (e.shiftKey) {
          // if shift key pressed for shift + tab combination
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus(); // add focus for the last focusable element
            e.preventDefault();
          }
        } else {
          // if tab key is pressed
          if (document.activeElement === lastFocusableElement) {
            // if focused has reached to last focusable element then focus first focusable element after pressing tab
            firstFocusableElement.focus(); // add focus for the first focusable element
            e.preventDefault();
          }
        }
      });
    }

    // Form submit handling
    const form = $('#searchform');
    const formMobile = $('#searchform-mobile');

    function onSubmit (e) {
      e.preventDefault();

      const searchTerm = e.currentTarget[0].value;

      // We only need to do this check if the radio buttons exist. Otherwise we just search marinet (welcome page).
      if (radioContainer.length) {
        const searchWebsite = e.currentTarget[3].checked;

        window.location.href = searchWebsite
          ? `/?s=${searchTerm}`
          : `https://marinet.bibliocommons.com/v2/search?query=${searchTerm}&searchType=smart`;
      } else {
        window.location.href = `https://marinet.bibliocommons.com/v2/search?query=${searchTerm}&searchType=smart`;
      }
    }

    form.submit((e) => onSubmit(e));
    formMobile.submit((e) => onSubmit(e));
  });
})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/search.js